import { render, staticRenderFns } from "./InstructorSignup.vue?vue&type=template&id=1d3737b6&"
import script from "./InstructorSignup.vue?vue&type=script&lang=js&"
export * from "./InstructorSignup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports